export const format12Hour = (time24) => {
    const [hours, minutes] = time24.split(":");
    const hour = parseInt(hours || "0");
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes || "00"} ${ampm}`;
};
export const formatShiftTimes = (startTime, endTime) => {
    if (!startTime || !endTime)
        return null;
    return `${format12Hour(startTime)} - ${format12Hour(endTime)}`;
};
//# sourceMappingURL=timeFormatUtils.js.map